"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const expoSensor_1 = require("../../../lib/expoSensor");
const logServer_1 = require("../../../lib/logServer");
const wa_1 = require("../../../lib/wa");
const wmLogger_1 = require("../../../lib/wmLogger");
const statRule_1 = require("./statRule");
const classnames_1 = require("classnames");
wmLogger_1.WmLogger.getRuleManager().setRules(statRule_1.default);
if (process.env.BROWSER) {
    require('./index.less');
}
class NoPicItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }
    componentDidMount() {
        expoSensor_1.default.addHook({
            el: this.ref.current,
            onExpo: () => {
                this.sendLog('product_expo');
                // this.props.onExpo && this.props.onExpo(this.props.commentItem);
            },
        });
    }
    render() {
        const { id, thumbnail, title, lowest_price, price, product_discount, } = this.props;
        return (React.createElement("div", { ref: this.ref, className: classnames_1.default('product-item', { 'product-itme_toko': this.props.isToko }), "data-id": id, onClick: this.handleClick.bind(this) },
            React.createElement("div", { className: "image" },
                React.createElement("img", { src: thumbnail })),
            React.createElement("div", { className: "info" },
                React.createElement("div", { className: "title" }, title),
                React.createElement("div", { className: "price" },
                    React.createElement("div", { className: "price1" }, lowest_price),
                    React.createElement("div", null,
                        React.createElement("del", { className: "price2" },
                            " ",
                            price),
                        React.createElement("span", { className: "discount" },
                            " -",
                            product_discount,
                            "%"))))));
    }
    sendLog(ac) {
        const { id, product_cate, pos, seedsite } = this.props;
        logServer_1.storyLogger().log({
            app: 'browser_product',
            ac,
            pos,
            product_id: id,
            seedsite,
            product_cate: product_cate || '',
        });
        wa_1.WaAction.log({
            ac_type: ac,
            ac_name: this.props.isToko ? 'tokopedia' : 'lazada',
            pos,
            product_id: id,
            seedsite,
            product_cate: product_cate || '',
        });
        /// 测试代码
        // WmLogger.log({
        //     test: '1',
        //  }, 'test');
    }
    handleClick() {
        const { productLink } = this.props;
        if (productLink) {
            this.sendLog('product_clk');
            location.href = productLink;
        }
    }
}
exports.default = NoPicItem;
//# sourceMappingURL=data:application/json;base64,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